// extracted by mini-css-extract-plugin
export default {"regionOverviewDescription":"RegionOverview_regionOverviewDescription__qX6bm"};